import { SettingOutlined } from "@ant-design/icons"
import { Button, Result } from "antd"
import { useTranslation } from "react-i18next"

import { useHub } from "./hub-context.ts"
import { useHubRights } from "./hub-rights.ts"

export const NoCommunicationAccess = () => {
  const { t } = useTranslation()
  const rights = useHubRights()
  const { openSettings } = useHub()
  return (
    <Result
      status="info"
      title={t("commHub.noTabs.title")}
      subTitle={
        rights.settings
          ? t("commHub.noTabs.settingsOnly")
          : t("commHub.noTabs.askAdmin")
      }
      extra={
        rights.settings ? (
          <Button
            type="primary"
            icon={<SettingOutlined aria-hidden />}
            onClick={() => openSettings("general")}
          >
            {t("commHub.header.settings")}
          </Button>
        ) : undefined
      }
    />
  )
}
